import {on, find, findIn, findAllIn} from "@elements/dom-utils";
import {onFind} from "@elements/init-modules-in-scope";

export function init() {

    //find active options of all .js-svg-compontent__input on page load
    let allInputs = findAllIn('.js-svg-compontent__input', document);
    allInputs.forEach((input) => {
        let activeOption = findIn('option:checked', input);
        let activeComponent = activeOption.getAttribute('data-svg-component');
        let activeElement = find('#' + activeComponent);

        if (activeElement) {
            activeElement.style.display = 'block';
        }
    });




    onFind('.js-svg-compontent__input', function (element) {
        on('change', function () {
            //find all svg-component and hide tem
            let allOptions = findAllIn('option', this);
            allOptions.forEach((option) => {
                let component = option.getAttribute('data-svg-component');
                if (!component) {
                    return;
                }
                let element = find('#' + component);
                if (element) {
                    element.style.display = 'none';
                }
            })

            //find active option of selected element and show the svg component
            let activeOption = findIn('option:checked', this);
            let activeComponent = activeOption.getAttribute('data-svg-component');

            //check if the active component is not null
            if (!activeComponent) {
                return;
            }

            let activeElement = find('#' + activeComponent);

            if (activeElement) {
                activeElement.style.display = 'block';
            }
        }, element);
    });
}